/* globals VXConfig */

import React                       from 'react';
import PropTypes                   from 'prop-types';
import Translations                from '../../../utils/Translations';
import Flux                        from '../../../flux/Flux';
import ReloadHelper                from '../../../utils/ReloadHelper';
import {OfferAction}               from '../DailybonusActions';
import {
	getGiftNameByLang, getTopUpGteThenValue, isMerchAndHasCode, needVipYesterdayOffer,
}                                  from '../dailyBonusHelpers';
import StringHelper                from '../../../utils/StringHelper';
import STYLES                      from "../../SimpleElements/VXButton/EnumVXButton";
import VXButton                    from "../../SimpleElements/VXButton/VXButton";
import { COLOR_TYPE_CALL_TO_ACTION,
	         COLOR_TYPE_DISABLED,
             COLOR_TYPE_TRANSPARENT} from "../../SimpleElements/VXButton/ButtonHelper";
import {VXButtonLineConfig}        from "../../SimpleElements/VXButton/VXButtonConfig";
import VXButtonOutline             from "../../SimpleElements/VXButton/Presets/VXButtonOutline";


const {offers} = Flux.Constants.DailyBonuses;

class DailyBonusOfferBtn extends React.Component {

	constructor(props) {
		super(props);
		this.actionBtnClick = this.actionBtnClick.bind(this);
	}

	actionBtnClick(wallpaperUrl) {
		const {content, offer, effect, purchased, conditions, quantity} = this.props;

		switch (offer) {
			case (offers.VIP):
				if (Flux.Guest.isVip()) {
					const url = VXConfig.isVXMobilePlatform ? content && content.mobile : wallpaperUrl;
					url && OfferAction.actionDownloadVipWallpapers(url);
				} else {
					OfferAction.actionBecomeVipOneDay(effect && effect.code ? effect.code : '');
				}
				break;
			case (offers.VIDEO):
			case (offers.PHOTO_ALBUM):
				if (purchased) {
					ReloadHelper.reload(content.linkVX);
					return;
				}
				OfferAction.actionVideoPhotoBuyWithBonus(content, this.props.free);
				break;
			case (offers.MESSENGER_GIFT):
				const giftName  = getGiftNameByLang(content && content.translations ? content.translations : []);
				const vxpayText = (quantity && giftName !== '') ? '+ ' + quantity + 'x ' + giftName : null;
				let topUpValue  = getTopUpGteThenValue(conditions);
				topUpValue      = isNaN(topUpValue) ? 0 : Number(topUpValue);
				OfferAction.actionGetMessengerGift(effect.code, topUpValue, vxpayText);
				break;
			case (offers.MERCHANDISE):
				OfferAction.actionMerchandise();
				break;
			case (offers.TOP_UP_PERCENT):
			case (offers.TOP_UP_FLAT):
			case (offers.VIDEO_VOUCHER):
				const needVip = needVipYesterdayOffer(conditions);
				OfferAction.openPayTourUi(effect.code, needVip, this.props.onSuccesFn);
				break;

			default:
		}
	}

	render() {
		const {offer, purchased, content, free} = this.props;
		const {topLevelClass}                   = this.props;
		const {btnClassName}                    = this.props;
		const {wallpaperBtnPostfix}             = this.props;
		const {buttonColor}                     = this.props;
		const videoPhotoOffer                   = offer === offers.VIDEO || offer === offers.PHOTO_ALBUM;
		const disableButton                     = purchased && !videoPhotoOffer;
		let actionBtnText                       = 'YearstadayBonusActionBtn' + offer;
		let offerBtnText                        = '';

		if (free) {
			actionBtnText = offer === offers.VIDEO ? 'DailyBonusFreeContentCTA' : 'DailyBonusFreeContentCTAGallery';
		}
		if (purchased) {
			actionBtnText = videoPhotoOffer ? 'View' : 'Redeemed365';
			offerBtnText  = (offer === offers.PHOTO_ALBUM ?  StringHelper.capitalize(offer).replace('_', ' ') : 'Bonus') + " ";
		}

		if (offer === offers.VIP && Flux.Guest.isVip()) {
			const {hd, fourK} = content ? content : {};
			actionBtnText     = 'actionVipOneDay365WithVipStatus';
			if (!VXConfig.isVXMobilePlatform) {
				return (
					<div className={topLevelClass}>
						<p className={`${topLevelClass}--text`}>
							{Translations.get('actionVipOneDay365WithVipStatus')} {Translations.get('vipAls365')}
						</p>
						<button onClick={this.actionBtnClick.bind(this, hd)}
						        disabled={!hd}
						        className={`${btnClassName} ${wallpaperBtnPostfix} h-mr-10`}
						>HD
						</button>
						<button onClick={this.actionBtnClick.bind(this, fourK)}
						        disabled={!fourK}
						        className={`${btnClassName} ${wallpaperBtnPostfix}`}
						>4K
						</button>
					</div>
				);
			}
		}

		if (offer === offers.VIDEO_VOUCHER) {
			actionBtnText = purchased ? 'Secured' : 'SecureNow';
		}

		if (offer === offers.MESSENGER_GIFT) {
			actionBtnText = this.props.purchased ? 'Redeemed365' : 'RewardGetGift';
		}

		if (offer === offers.TOP_UP_PERCENT) {
			actionBtnText = this.props.purchased ? 	'Redeemed365'	: 'RedeemVoucher';
		}

		const hasCode    = isMerchAndHasCode(this.props.offer, this.props.effect);
		const btnClasses = [topLevelClass];

		hasCode && btnClasses.push('-has-code');
		const voucherText = this.props.isCurrencyVoucher ? StringHelper.capitalize(Translations.get('Redeem')) : '';
		const Button      = this.props.isOutlineButton ? VXButtonOutline : VXButton;

		if (voucherText && !this.props.purchased) {
			return (
				<div className={btnClasses.join(' ')}>
					<Button color={this.props.isOutlineButton ? COLOR_TYPE_TRANSPARENT  : (disableButton ? COLOR_TYPE_DISABLED : COLOR_TYPE_CALL_TO_ACTION)}
					        line1={[new VXButtonLineConfig(voucherText)]}
					        onClick={this.actionBtnClick}
					        icon={'-icon-voucher-icon'}
					        size={VXConfig.device.isTablet ? STYLES.SIZE.SMALL : STYLES.SIZE.BIG}
					        disabled={disableButton}
							staticMode={true}
					/>
				</div>
			);
		}

		return (
			<div className={btnClasses.join(' ')}>
				{hasCode && <code className='discount-code'>{this.props.effect.code}</code>}
				<Button color={this.props.isOutlineButton ? COLOR_TYPE_TRANSPARENT  : (buttonColor ? buttonColor : (disableButton ? COLOR_TYPE_DISABLED :  COLOR_TYPE_CALL_TO_ACTION))}
				        line1={[new VXButtonLineConfig(offerBtnText + Translations.get(actionBtnText))]}
				        onClick={this.actionBtnClick}
				        size={VXConfig.device.isTablet ? STYLES.SIZE.SMALL : STYLES.SIZE.BIG}
				        disabled={disableButton}
				        staticMode={true}
				/>
			</div>
		);
	}

}

DailyBonusOfferBtn.propTypes = {
	content:             PropTypes.object,
	offer:               PropTypes.oneOf([
		Flux.Constants.DailyBonuses.offers.VIDEO,
		Flux.Constants.DailyBonuses.offers.VIDEO_VOUCHER,
		Flux.Constants.DailyBonuses.offers.PHOTO_ALBUM,
		Flux.Constants.DailyBonuses.offers.VIP,
		Flux.Constants.DailyBonuses.offers.TOP_UP_PERCENT,
		Flux.Constants.DailyBonuses.offers.TOP_UP_FLAT,
		Flux.Constants.DailyBonuses.offers.MERCHANDISE,
		Flux.Constants.DailyBonuses.offers.MESSENGER_GIFT,
	]),
	effect:              PropTypes.object,
	purchased:           PropTypes.bool,
	free:                PropTypes.bool,
	conditions:          PropTypes.array,
	quantity:            PropTypes.number,
	btnClassName:        PropTypes.string,
	topLevelClass:       PropTypes.string,
	wallpaperBtnPostfix: PropTypes.string,
	isCurrencyVoucher:   PropTypes.bool,
	isOutlineButton:     PropTypes.bool,
	buttonColor:         PropTypes.string,
	onSuccesFn:          PropTypes.func
};

DailyBonusOfferBtn.defaultProps = {
	free:                false,
	purchased:           false,
	btnClassName:        'btn -btn-color-special',
	topLevelClass:       'dailybonus-today-item__right-side__action-btn',
	wallpaperBtnPostfix: '',
	conditions:          [],
	isCurrencyVoucher:   false,
	isOutlineButton:     false,
	buttonColor:         '',
	onSuccesFn:          null
};

export default DailyBonusOfferBtn;
